import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "byte",
    standalone: false
})
export class BytePipe implements PipeTransform {
    transform(rawNum: number): string {
        if (rawNum >= 1000000) {
            return  Math.round(rawNum/1000000) + "MB"
        } else if (rawNum >= 1000) {
            return  Math.round(rawNum/1000) + "KB"
        }
        return rawNum + "B";
    }
}